module.exports = __webpack_public_path__ + "img/스마트그늘막 (1).252914c8.jpg";